import _ from 'lodash'

const menu = [
  {
    title: 'Dashboard',
    route: {name: 'BoDashboard'},
    menu: 'BoDashboard',
    icon:  'icon-speedometer',
  },
  {
    cap: 'Website Management',
    relate: [
      'BoHome',
      'BoAboutUs',
      'BoProducts',
      'BoProductCategory',
      'ArticleCat',
      'BoBlog',
      'BoBlogCategory',
      'BoContact',
      'BoMitra',
      'BoOffice',
      // 'BoApplicants',
      'BoClients',
      'BoProcurementSolution',
      'BoProcurementOfService',
      'BoCTA',
      'BoFaq',
      'BoTermCondition',
      'BoPrivacyPolice',
      'BoWebSettings',
      'StaticSEO',
    ]
  },
  {
    title: 'Home',
    route: {name: 'BoHome'},
    icon:  'ti-home',
    menu: 'BoHome'
  },
  {
    title: 'About Us',
    route: {name: 'BoAboutUs'},
    icon:  'icon-people',
    menu: 'BoHome'
  },
  {
    title: 'Clients',
    route: {name: 'BoClients'},
    icon:  'ti-id-badge',
    menu: 'BoClients'
  },
  {
    title: 'Procurement Solution',
    route: {name: 'BoProcurementSolution'},
    icon:  'ti-bookmark-alt',
    menu: 'BoProcurementSolution'
  },
  {
    title: 'Procurement of Service',
    route: {name: 'BoProcurementOfService'},
    icon:  'ti-settings',
    menu: 'BoProcurementOfService'
  },
  {
    title: 'Order',
    route: {name: 'BoOrder'},
    icon:  'ti-agenda',
    menu: 'BoOrder'
  },
  {
    title: 'CTA',
    route: {name: 'BoCTA'},
    icon:  'ti-folder',
    menu: 'BoCTA'
  },
  {
    title: 'FAQ',
    icon:  'ti-help-alt',
    children: [
      {
        title: 'FAQ List',
        route: {
          name: 'BoFaq'
        },
        menu: 'BoFaq'
      },
      {
        title: 'FAQ Category',
        route: {
          name: 'BoFaqCategory'
        },
        menu: 'BoFaqCategory'
      },
    ],
  },
  {
    title: 'Products',
    icon: 'icon-social-dropbox',
    children: [
      {
        title: 'Product List',
        route: {
          name: 'BoProducts'
        },
        menu: 'BoProducts'
      },
      {
        title: 'Product Category',
        route: {
          name: 'BoProductCategory'
        },
        menu: 'BoProductCategory'
      },
    ],
  },
  {
    title: 'Blog',
    icon: 'ti-layout-list-thumb',
    route: {
      name: 'BoBlog'
    },
    menu: 'BoBlog',
  },
  {
    title: 'Contact Us',
    icon:  'icon-paper-plane',
    children: [
      {
        title: 'Contact List',
        route: {name: 'BoContact'},
        menu: 'BoContact'
      },
      {
        title: 'Contact Page',
        route: {name: 'BoContactPage'},
        menu: 'BoContactPage'      
      },
    ]
  },
  {
    title: 'Mitra',
    icon:  'ti-package',
    children: [
      {
        title: 'Mitra List',
        route: {name: 'BoMitra'},
        menu: 'BoMitra'
      },
      {
        title: 'Mitra Page',
        route: {name: 'BoMitraPage'},
        menu: 'BoMitraPage'      
      },
    ]
  },
  {
    title: 'Legal',
    icon: 'icon-docs',
    children: [{
        title: 'Terms and Conditions',
        route: {
          name: 'BoTermCondition',
          params: {
            pageSlug: 'terms-and-conditions'
          }
        },
        menu: 'BoTermCondition',

      },
      {
        title: 'Privacy Policy',
        route: {
          name: 'BoPrivacyPolice',
          params: {
            pageSlug: 'privacy-policy'
          }
        },
        menu: 'BoPrivacyPolice',

      },
    ]
  },
  {
    title: 'Web Settings',
    icon: 'icon-wrench',
    route: { name: 'BoWebSettings' },
    menu: 'BoWebSettings'
  },
  {
    cap: 'CMS Settings',
    relate: [
      'Users',
      'BoUserLevel'
    ]
  },
  {
    title: 'User Management',
    icon: 'icon-user-follow',
    children: [
      {
        title: 'User List',
        route: {name: 'Users'},
        menu: 'Users'
      },
      {
        title: 'User Level',
        route: {name: 'BoUserLevel'},
        menu: 'BoUserLevel'
      },
    ],
  },
  // {
  //   title: 'AuditTrail',
  //   route: {
  //     name: 'AuditTrail'
  //   },
  //   icon: 'icon-check',
  //   menu: 'AuditTrail'
  // },
]

let nav = menu

const accessAll = localStorage.getItem('u_menu_all')
if (accessAll == 'N') {
  let menuRole = JSON.parse(localStorage.getItem('u_menu') || '[]')
  menuRole = _.map(menuRole, v => {
    return v.menu
  })
  
  nav = _.filter(nav, v => {
    if (v.cap) {
      return _.filter(v.relate, v2 => {
        return menuRole.indexOf(v2) > -1
      }).length >= 1
    } 
    else if (v.children) {
      return _.filter(v.children, v2 => {
        return menuRole.indexOf(v2.menu) > -1
      }).length >= 1
    } 
    else {
      return menuRole.indexOf(v.menu) > -1
    }
  })

  nav = _.map(nav, v => {
    if (v.children) {
      v.children = _.filter(v.children, v2 => {
        return menuRole.indexOf(v2.menu) > -1
      })
    }

    return v
  })
}

export default nav